import { BrandLockup } from "./Navbar";
import { Linkedin, Facebook, Instagram, Youtube, Twitter } from "lucide-react";

const SOCIALS = [
  { icon: Linkedin, href: "https://www.linkedin.com/company/frantiger", label: "LinkedIn" },
  { icon: Twitter, href: "https://www.twitter.com/iamfrantiger", label: "Twitter" },
  { icon: Facebook, href: "https://www.facebook.com/iamfrantiger", label: "Facebook" },
  { icon: Instagram, href: "https://www.instagram.com/iamfrantiger/", label: "Instagram" },
  { icon: Youtube, href: "https://www.youtube.com/@iamfrantiger", label: "YouTube" },
];

const LINK_GROUPS = [
  {
    title: "Platform",
    links: [
      { label: "frantiger.biz — Franchise Marketplace", href: "https://frantiger.biz" },
      { label: "frantiger.agency — Brand Services", href: "https://frantiger.agency" },
      { label: "Explore Franchise Opportunities", href: "https://frantiger.biz/listing" },
      { label: "List Your Brand", href: "https://frantiger.biz/submit-listing" },
    ],
  },
  {
    title: "Trust & Safety",
    links: [
      { label: "Not an Investment Advisory (Disclosure)", href: "https://frantiger.biz/not-an-investment-advisory-disclosure" },
      { label: "Mandatory Risk Disclosure", href: "https://frantiger.biz/mandatory-risk-disclosure" },
      { label: "Terms of Use", href: "https://frantiger.biz/kyc-terms-conditions" },
      { label: "Privacy Policy", href: "https://frantiger.biz/privacy-policy" },
    ],
  },
];

export default function Footer({ base = "" }) {
  return (
    <footer data-testid="footer-section" className="bg-slate-950 pb-10 pt-16 text-slate-400">
      <div className="mx-auto max-w-6xl px-4">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_0.9fr_0.9fr]">
          <div>
            <BrandLockup dark base={base} />
            <p className="mt-5 max-w-sm text-sm leading-relaxed">
              fraction by frantiger makes fractional franchise participation simple for everyday
              Indian investors — small tickets, real outlets, professional operators.
            </p>
            <div className="mt-6 flex gap-2.5">
              {SOCIALS.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-800/80 text-slate-300 transition-colors hover:bg-orange-500 hover:text-white"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
          {LINK_GROUPS.map((g) => (
            <div key={g.title}>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-400">{g.title}</p>
              <ul className="mt-4 space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} target="_blank" rel="noopener noreferrer" className="text-sm transition-colors hover:text-orange-400">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-3xl bg-slate-900/80 p-6 text-[11px] leading-relaxed text-slate-500" data-testid="footer-disclaimer">
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.15em] text-slate-300">Disclaimer (India)</p>
          <p>
            frantiger® is not an investment advisor and is not registered with SEBI as an Investment
            Adviser, Research Analyst, Broker, or Intermediary. Nothing on this page constitutes
            investment, securities, financial, tax, or legal advice. We are currently collecting
            expressions of interest regarding potential fractional participation in franchise
            opportunities for exploratory purposes only. This is not an offer, solicitation, or
            invitation to invest. frantiger® and its representatives do not request or accept money
            for "fractional investment." If anyone seeks payments or commitments claiming to
            represent frantiger®, do not proceed — report it to{" "}
            <a href="mailto:911@frantiger.biz" className="font-semibold text-orange-400">911@frantiger.biz</a>.
            Users must conduct independent due diligence and, where appropriate, consult
            SEBI-registered professionals before making financial decisions.
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-slate-800/80 pt-6 text-xs sm:flex-row">
          <p>© 2017–2026 FranTiger Business Consulting (P) Ltd. · CIN: U74999KA2018PTC110354</p>
          <p>4th Floor, Manasa Residency, Electronic City Phase 1, Bengaluru · <a href="tel:+919548444445" className="hover:text-orange-400">+91 95484 44445</a></p>
        </div>
      </div>
    </footer>
  );
}
